import { helpers } from "@vuelidate/validators";
import createMessageWithParams from "./createMessageWithParams.mjs";
const regex = (pattern, customMessage) => helpers.withMessage(
  customMessage || createMessageWithParams("The field format is invalid"),
  (value) => {
    if (!value)
      return true;
    const regexPattern = typeof pattern === "string" ? new RegExp(pattern) : pattern;
    return regexPattern.test(value);
  }
);
const oneOf = (allowedValues, customMessage) => helpers.withMessage(
  customMessage || createMessageWithParams("The field is not a valid value"),
  (value) => {
    if (!value)
      return true;
    return allowedValues.includes(value);
  }
);
const after = (targetDate, customMessage) => helpers.withMessage(
  customMessage || "Date is out of range",
  (value) => {
    if (!value)
      return true;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || !/^\d{4}-\d{2}-\d{2}$/.test(targetDate)) {
      return false;
    }
    return new Date(value) > new Date(targetDate);
  }
);
const before = (targetDate, customMessage) => helpers.withMessage(
  customMessage || "Date is out of range",
  (value) => {
    if (!value)
      return true;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || !/^\d{4}-\d{2}-\d{2}$/.test(targetDate)) {
      return false;
    }
    return new Date(value) < new Date(targetDate);
  }
);
export { regex, oneOf, after, before };
